// extracted by mini-css-extract-plugin
module.exports = {"container":"RecordStatus_container__-p5Td","status":"RecordStatus_status__15CMw","statusOnline":"RecordStatus_statusOnline__2ceAu"};